export default "__VITE_ASSET__589a098e__"